
import {Booking} from '@shared/models/data-models/booking.model';

export class TimeSlot extends Booking {
}
